import { render, staticRenderFns } from "./answer-questions3.vue?vue&type=template&id=255427ca&scoped=true&"
import script from "./answer-questions3.vue?vue&type=script&lang=js&"
export * from "./answer-questions3.vue?vue&type=script&lang=js&"
import style0 from "./answer-questions3.vue?vue&type=style&index=0&id=255427ca&lang=scss&scoped=true&"
import style1 from "./answer-questions3.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255427ca",
  null
  
)

export default component.exports